"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CSPreOrderDetailsComponent = void 0;
const core_1 = require("@angular/core");
const router_1 = require("@angular/router");
const ng_bootstrap_1 = require("@ng-bootstrap/ng-bootstrap");
const shared_1 = require("../../../mma/shared");
const orderStatus_service_1 = require("../../services/orderStatus.service");
const constants = require("../../util/constants");
const preorderlookup_component_1 = require("../shared/preorder-lookup/preorderlookup.component");
class CSPreOrderDetailsComponent extends preorderlookup_component_1.CSPreorderLookupOrderComponent {
    constructor(modalService, orderService, genericContentService, router) {
        super(orderService, genericContentService);
        this.modalService = modalService;
        this.orderService = orderService;
        this.genericContentService = genericContentService;
        this.router = router;
        this.paymentMethod = constants.paymentMethod;
        this.isAccessory = false;
    }
    ngOnDestroy() {
        this.modelRef = this.modalService.dismissAll();
    }
    ngOnInit() {
        this.getPreOrderDetails();
    }
    /**
     * @returns cached pre order details
     */
    getPreOrderDetails() {
        var _a, _b;
        if (this.orderService.preOrderData) {
            this.preOrderData = this.orderService.preOrderData;
            this.subcriptionDetails = (_a = this.orderService.preOrderData) === null || _a === void 0 ? void 0 : _a.preOrderSubscriptionDetails;
            this.isLoggedInUser = ((_b = this.orderService.preOrderData) === null || _b === void 0 ? void 0 : _b.securityStatus) === 4;
            this.getOrderSummary();
        }
        else {
            this.router.navigate(['/']);
        }
    }
    editPayment() {
        if (this.isLoggedInUser && this.preOrderData) {
            this.router.navigate(['/preorder/' + this.preOrderData.preorderId]);
        }
        else {
            this.modelRef = this.modalService.open(this.modalData, { centered: true });
        }
    }
    openCancelEstoreAccessoryModal(event) {
        if (event) {
            this.isAccessory = true;
            this.editDevice();
        }
    }
    editDevice() {
        if (this.isLoggedInUser && this.preOrderData) {
            this.router.navigate(['/preorder/' + this.preOrderData.preorderId]);
        }
        else if (this.isAccessory) {
            this.modelRef = this.modalService.open(this.modalAccessory, { centered: true });
        }
        else {
            this.modelRef = this.modalService.open(this.modalDevice, { centered: true });
        }
    }
    enterSSN() {
        this.ssnErrorMessage = '';
        this.lastFourDigitSsn = '';
        this.modelRef = this.modalService.open(this.modalSSN, { centered: true });
    }
    /**
     * validate SSN
     */
    continueWithSSN(lastFourDigitSsn) {
        this.loader = true;
        this.orderService
            .validateSSN({
            validateSSN: true,
            accountId: this.preOrderData.accountId,
            lastFourSSN: lastFourDigitSsn,
            preorderId: this.preOrderData.preorderId
        })
            .subscribe((response) => {
            this.loader = false;
            if (response.success === 'true') {
                this.ssnErrorMessage = '';
                this.router.navigate(['/preorder/' + this.preOrderData.preorderId]);
            }
            else {
                this.ssnInvalid = true;
                this.ssnErrorMessage = constants.invalidSSN;
                this.lastFourDigitSsn = '';
            }
        });
    }
    /**
     * @returns redirects the user to sign in page
     */
    goToSignIn() {
        location.href = constants.loginUrl;
        this.modelRef.close();
    }
    openEditPaymentModal(event) {
        if (event) {
            this.editPayment();
        }
    }
    openEnterSSNModal(event) {
        if (event) {
            this.enterSSN();
        }
    }
}
exports.CSPreOrderDetailsComponent = CSPreOrderDetailsComponent;
//# sourceMappingURL=preorderdetails.component.js.map